/**
 * API Configuration
 *
 * Central configuration for API endpoints and base URL.
 * Uses REACT_APP_API_URL environment variable set in .env.development / .env.production.
 */
export const API_BASE_URL =
  process.env.REACT_APP_API_URL ||
  "https://rg0empmpja.execute-api.ca-central-1.amazonaws.com";

/**
 * API Endpoints
 * Common API endpoints used across the application
 */
export const API_ENDPOINTS = {
  // Auth endpoints
  AUTH: {
    LOGIN: "/login",
    LOGOUT: "/logout",
    REFRESH: "/auth/refresh-token",
    VALIDATE: "/auth/validate-session",
  },

  // Admin endpoints
  ADMIN: {
    PROFILE: "/admin/profile",
    USERS: "/users",
    KPIS: "/admin/kpis",
    ANALYTICS: "/admin/analytics",
  },

  // Announcement endpoints
  ANNOUNCEMENTS: {
    GENERAL: "/admin/announcements/general",
  },

  // Feedback endpoints
  FEEDBACK: "/admin/feedback",

  // FAQ endpoints
  FAQS: "/admin/faqs",

  // Topics endpoints
  TOPICS: "/admin/topics-of-interest",

  // Privacy Policy endpoints
  PRIVACY_POLICY: "/privacy-policy",

  // Terms of Use endpoints
  TERMS_OF_USE: "/terms-of-use",

  // Contact Info endpoints
  CONTACT_INFO: "/admin/contact-info",

  // Notification endpoints
  NOTIFICATIONS: "/notifications",

  // App Version endpoints
  APP_VERSION: "/app-version",

  // Care Center endpoints
  CARE_CENTER: {
    REGISTER: "/care-centers/register",
  },
} as const;

const apiConfig = {
  API_BASE_URL,
  API_ENDPOINTS,
};

export default apiConfig;
